import clsx from 'clsx'
import React from 'react'
import { Box, Grid, makeStyles } from '@material-ui/core'
import VisualBalanceEmptyState from '../../../../VisualBalanceSheetV2/VisualBalanceEmptyState'
import BlockItem from '../Blocks/BlockItem'
import { useVisualBlocksContext, VisualBlocksProvider } from '../VisualBlocksContext'
import { VisualBlockListProps } from '../propTypes'
import SplitList from './SplitList'
import LoadingState from './LoadingState'

const useStyles = makeStyles(() => ({
  divider: {
    opacity: 0.2,
    margin: '2rem 0',
    width: '100%'
  }
}))

function VisualBlockListContent () {
  const classes = useStyles()

  const { data, isLoading, classNames, styles, listLayout } =
    useVisualBlocksContext()

  if (isLoading) {
    return <LoadingState />
  }

  if (!data?.length) {
    return (
      <div
        className={clsx(
          'flex flex-col gap-2 h-full items-center justify-center',
          classNames?.container
        )}
        style={{ minHeight: '500px', ...(styles?.container ?? {}) }}
      >
        <div className='w-full' style={{ maxWidth: '800px' }}>
          <VisualBalanceEmptyState />
        </div>
      </div>
    )
  }

  return (
    <>
      {
        listLayout === 'sideBySide' ? (
          <Grid container spacing={4} sx={{ width: '100%' }}>
            <Grid item xs={6}>
              {data.filter(x => x.isSeparated === false).map((item, itemIndex) => (
                <>
                  {itemIndex !== 0 && <Box className={classes.divider} />}
                  <div className='flex flex-1 gap-5' key={item.id}>
                    <BlockItem
                      labelLocation='inside'
                      depth={0}
                      fixedWidth='240px'
                      label={item.label}
                      value={item.value}
                      color={item.color}
                      labelSize='lg'
                    />
                    <SplitList item={item} />
                  </div>
                </>
              ))}
            </Grid>
            <Grid item xs={6}>
              {data.filter(x => x.isSeparated === true).map((item, itemIndex) => (
                <>
                  {itemIndex !== 0 && <Box className={classes.divider} />}
                  <div className='flex flex-1 gap-5' key={item.id}>
                    <BlockItem
                      labelLocation='inside'
                      depth={0}
                      fixedWidth='240px'
                      label={item.label}
                      value={item.value}
                      color={item.color}
                      labelSize='lg'
                    />
                    <SplitList item={item} />
                  </div>
                </>
              ))}
            </Grid>
          </Grid>
        ) : (
          <div
            className={clsx('flex h-full w-full items-start', classNames?.container)}
            style={{ minHeight: '500px', gap: '24px', ...(styles?.container ?? {}) }}
          >
            {data.map((item, itemIndex) => (
              <div className='flex flex-1 gap-5' key={item.id}>
                <BlockItem
                  labelLocation='inside'
                  depth={0}
                  fixedWidth='240px'
                  label={item.label}
                  value={item.value}
                  color={item.color}
                  labelSize='lg'
                />
                <SplitList item={item} />
              </div>
            ))}
          </div>
        )
      }
    </>
  )
}

function PipelineVisualBlockList (props) {
  return (
    <VisualBlocksProvider {...props}>
      <VisualBlockListContent />
    </VisualBlocksProvider>
  )
}

PipelineVisualBlockList.propTypes = VisualBlockListProps

export default PipelineVisualBlockList
